import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit/src/theme/types';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import React from 'react';
import { ChevronDown } from 'react-feather';
const styles = (theme: JupiterTheme) =>
  createStyles({
    headerChevron: {
      color: theme.palette.coolGrey[400],
      margin: theme.spacing(0, 0.625, 0, 0.5),
      transition: 'transform 0.3s',
      '&[data-caret-state="open"]': {
        transform: 'rotate(-180deg)',
      },
    },
    sectionHeading: {
      alignItems: 'center',
      cursor: 'pointer',
      color: theme.palette.coolGrey[400],
      display: 'flex',
      fontSize: 12,
      fontWeight: 'bold',
      justifyContent: 'space-between',
      letterSpacing: 1.6,
      textTransform: 'uppercase',
      padding: theme.spacing(1.5, 0, 1.5, 0.625),
    },
  });

interface Props extends WithStyles<typeof styles> {
  onClick: () => void;
  open: boolean;
  title: string;
}

export const FilterPanelHeader = ({ onClick, open, title, classes }: Props) => {
  return (
    <header className={classes.sectionHeading} onClick={onClick}>
      {title}
      <ChevronDown
        data-caret-state={open ? 'open' : ''}
        size={16}
        className={classes.headerChevron}
        data-testid="iconHeader"
      />
    </header>
  );
};
export default withStyles(styles)(FilterPanelHeader);
